import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAllMenu } from "redux/features/menu";
import { message } from "antd";
import { fetchAllMenuType } from "redux/features/menuType";

export const useMenu = () => {
  const [data, setData] = useState([]);
  const [menuTypes, setMenuTypes] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    sort: "created_at",
    total_data: 0,
  });

  const dispatch = useDispatch();
  const [metaData, setMetaData] = useState({});

  const getData = async (params) => {
    try {
      setLoading(true);
      const response = await dispatch(fetchAllMenu(params)).unwrap();
      setMetaData(response.meta.page);
      setData(response.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error?.message || "Failed to fetch data");
    }
  };

  const getMenuTypes = async () => {
    try {
      const response = await dispatch(fetchAllMenuType()).unwrap();
      const mappedType = response.data.map((data) => {
        return {
          label: data.name,
          value: data.name,
        };
      });
      setMenuTypes(mappedType);
    } catch (error) {
      message.error(error?.message || "Failed to fetch data");
    }
  };

  useEffect(() => {
    getMenuTypes();
  }, []);

  useEffect(() => {
    getData(filters);
  }, [filters]);

  return {
    data,
    getData,
    menuTypes,
    filters,
    setFilters,
    getMenuTypes,
    isLoading,
    metaData,
  };
};
